<app-reports-log
    [reports]="reports"
    (downloadReport)="onDownloadReport($event)">
</app-reports-log>
